// src/enums.ts
var e = (...v) => v;
var STAFF_ROLES = e("SUPER_ADMIN", "LIBRARY_ADMIN", "LIBRARIAN", "CIRCULATION_CLERK", "CATALOGER", "ACQUISITIONS", "VOLUNTEER", "GUARD");
var PATRON_CATEGORY_TYPES = e("ADULT", "CHILD", "PROFESSIONAL", "STAFF", "INSTITUTIONAL", "STATISTICAL");
var PATRON_STATUSES = e("ACTIVE", "INACTIVE", "DELETED");
var GENDERS = e("MALE", "FEMALE", "OTHER", "UNSPECIFIED");
var PRIVACY_POLICIES = e("DEFAULT", "FOREVER", "NEVER");
var NOT_FOR_LOAN_STATUSES = e("LOANABLE", "NOT_FOR_LOAN", "REFERENCE_ONLY", "STAFF_COLLECTION", "ON_ORDER", "IN_PROCESSING", "ON_DISPLAY");
var LOST_STATUSES = e("NONE", "LOST", "LONG_OVERDUE", "LOST_AND_PAID", "MISSING_IN_INVENTORY", "CLAIMED_RETURNED");
var HOLD_STATUSES = e("PENDING", "WAITING", "IN_TRANSIT", "IN_PROCESSING", "FILLED", "CANCELLED", "EXPIRED");
var TRANSFER_REASONS = e("HOLD", "RETURN_TO_HOME", "STOCK_ROTATION", "MANUAL", "RECALL", "COURSE_RESERVE");
var LOAN_UNITS = e("DAYS", "HOURS");
var DEBIT_TYPES = e("OVERDUE", "LOST_ITEM", "MANUAL_FEE", "NEW_CARD", "MEMBERSHIP", "PROCESSING", "RENTAL", "HOLD_FEE", "ARTICLE_REQUEST", "ROOM_BOOKING", "ILL_FEE", "DAMAGE", "OTHER");
var CREDIT_TYPES = e("PAYMENT", "WRITEOFF", "FORGIVEN", "DISCOUNT", "MANUAL_CREDIT", "LOST_ITEM_REFUND", "REFUND", "CANCELLATION");
var PAYMENT_METHODS = e("CASH", "UPI", "CARD", "NET_BANKING", "CHEQUE", "BANK_TRANSFER", "ONLINE", "OTHER");
var NOTICE_MEDIUMS = e("EMAIL", "SMS", "PRINT", "PUSH", "WHATSAPP");
var MESSAGE_STATUSES = e("PENDING", "SENT", "FAILED", "CANCELLED", "SKIPPED");
var LIST_VISIBILITIES = e("PRIVATE", "SHARED", "PUBLIC");
var BASKET_STATUSES = e("OPEN", "CLOSED", "ORDERED", "RECEIVING", "DONE");
var ORDER_STATUSES = e("NEW", "ORDERED", "PARTIAL", "RECEIVED", "CANCELLED");
var SUGGESTION_STATUSES = e("PENDING", "ACCEPTED", "REJECTED", "ORDERED", "AVAILABLE");
var SUBSCRIPTION_FREQUENCIES = e("DAILY", "WEEKLY", "FORTNIGHTLY", "MONTHLY", "BIMONTHLY", "QUARTERLY", "SEMIANNUAL", "ANNUAL", "IRREGULAR");
var SERIAL_ISSUE_STATUSES = e("EXPECTED", "ARRIVED", "LATE", "MISSING", "CLAIMED", "NOT_PUBLISHED", "DELETED");
var ILL_STATUSES = e("REQUESTED", "REVIEWED", "ORDERED", "IN_TRANSIT", "RECEIVED", "OVERDUE", "RETURNED", "COMPLETED", "CANCELLED", "UNAVAILABLE");
var EVENT_STATUSES = e("DRAFT", "PUBLISHED", "CANCELLED", "COMPLETED");
var BOOKING_STATUSES = e("PENDING", "CONFIRMED", "CANCELLED", "COMPLETED", "NO_SHOW");
var IMPORT_SOURCES = e("KOHA_DB", "KOHA_API", "KOHA_FILES");
var IMPORT_STATUSES = e("PENDING", "RUNNING", "COMPLETED", "COMPLETED_WITH_ERRORS", "FAILED", "CANCELLED", "ROLLED_BACK");
var HARD_DUE_DATE_MODES = e("BEFORE", "EXACT", "AFTER");

// src/permissions.ts
var PERMISSIONS = [
  "superlibrarian",
  "circulate",
  "override_circulation",
  "catalogue",
  "editcatalogue",
  "editauthorities",
  "borrowers",
  "borrowers_delete",
  "permissions",
  "reserveforothers",
  "updatecharges",
  "writeoff",
  "cash_management",
  "acquisition",
  "serials",
  "courses",
  "reports",
  "tools",
  "parameters",
  "management",
  "lists",
  "clubs",
  "ill",
  "erm",
  "events",
  "news",
  "import",
  "audit",
  "gate_check"
];
var PERMISSION_LABELS = {
  superlibrarian: "Everything (super librarian)",
  circulate: "Circulation desk (check out, check in, renew, holds)",
  override_circulation: "Override circulation blocks and confirmations",
  catalogue: "Search the staff catalogue",
  editcatalogue: "Create and edit bibliographic records and items",
  editauthorities: "Edit authority records",
  borrowers: "View and edit patrons",
  borrowers_delete: "Delete or anonymise patrons",
  permissions: "Manage staff permissions",
  reserveforothers: "Place and manage holds for other patrons",
  updatecharges: "Manage fines and fees",
  writeoff: "Write off and forgive charges",
  cash_management: "Open and close cash registers",
  acquisition: "Acquisitions and budgets",
  serials: "Serials and subscriptions",
  courses: "Course reserves",
  reports: "Run and create reports",
  tools: "Staff tools (labels, batch edits, inventory, notices)",
  parameters: "System preferences and authorised values",
  management: "Libraries, categories, item types and circulation rules",
  lists: "Manage public lists",
  clubs: "Manage clubs and reading challenges",
  ill: "Interlibrary loans",
  erm: "Electronic resources",
  events: "Events, rooms and bookings",
  news: "News and announcements",
  import: "Data imports (MARC and Koha migration)",
  audit: "View audit logs",
  gate_check: "Gate check: scan a book or card to see who it is issued to"
};
var CIRC = ["gate_check", "circulate", "catalogue", "borrowers", "reserveforothers", "updatecharges", "lists"];
var ROLE_PERMISSIONS = {
  SUPER_ADMIN: ["superlibrarian"],
  LIBRARY_ADMIN: [...CIRC, "override_circulation", "editcatalogue", "editauthorities", "borrowers_delete", "permissions", "writeoff", "cash_management", "acquisition", "serials", "courses", "reports", "tools", "parameters", "management", "clubs", "ill", "erm", "events", "news", "import", "audit"],
  LIBRARIAN: [...CIRC, "override_circulation", "editcatalogue", "editauthorities", "writeoff", "cash_management", "serials", "courses", "reports", "tools", "clubs", "ill", "events", "news"],
  CIRCULATION_CLERK: [...CIRC, "cash_management"],
  CATALOGER: ["catalogue", "editcatalogue", "editauthorities", "serials", "tools", "lists"],
  ACQUISITIONS: ["catalogue", "acquisition", "serials", "reports"],
  VOLUNTEER: ["catalogue", "circulate", "gate_check"],
  /** Door guard: may only scan a book or card and see whether it is issued, and to whom. */
  GUARD: ["gate_check"]
};
function effectivePermissions(role, extra = []) {
  const set = new Set(role ? ROLE_PERMISSIONS[role] : []);
  for (const p of extra) {
    set.add(p);
  }
  return [...set].filter((p) => PERMISSIONS.includes(p));
}
function hasPermission(granted, needed) {
  return granted.includes("superlibrarian") || granted.includes(needed);
}

// src/libraries.ts
var WEEKDAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
var HOLIDAY_KINDS = ["SINGLE", "WEEKLY_REPEAT", "YEARLY_REPEAT"];

// src/catalog.ts
var BARCODE_FORMATS = ["code128", "code39", "ean13", "qrcode", "datamatrix", "interleaved2of5"];
var AUTHORITY_TYPE_CODES = [
  "PERSO_NAME",
  "CORPO_NAME",
  "MEETI_NAME",
  "UNIF_TITLE",
  "TOPIC_TERM",
  "GEOGR_NAME",
  "GENRE/FORM",
  "CHRON_TERM"
];
var CSV_IMPORT_FIELDS = [
  "title",
  "subtitle",
  "author",
  "additionalAuthors",
  "isbn",
  "issn",
  "publisher",
  "publicationPlace",
  "publicationYear",
  "edition",
  "series",
  "language",
  "subjects",
  "genres",
  "summary",
  "notes",
  "ddc",
  "lcc",
  "extent",
  "barcode",
  "accessionNumber",
  "copies",
  "callNumber",
  "library",
  "itemType",
  "location",
  "collection",
  "price",
  "replacementPrice",
  "copyNumber",
  "dateAccepted",
  "source",
  "publicNote",
  "staffNote"
];

// src/circulation.ts
var RECALL_STATUSES = ["REQUESTED", "WAITING", "IN_TRANSIT", "OVERDUE", "FINISHED", "CANCELLED", "EXPIRED"];
var ARTICLE_REQUEST_STATUSES = ["PENDING", "PROCESSING", "COMPLETED", "CANCELLED"];
var OFFLINE_OP_TYPES = ["CHECKOUT", "CHECKIN", "RENEW", "PAYMENT"];
var OFFLINE_OP_STATUSES = ["PENDING", "APPLIED", "FAILED"];
var CIRCULATION_ISSUE_CATALOG = {
  // lookup
  PATRON_NOT_FOUND: { kind: "BLOCK", description: "No patron matches the card number or id." },
  ITEM_NOT_FOUND: { kind: "BLOCK", description: "No item has this barcode." },
  BIBLIO_NOT_FOUND: { kind: "BLOCK", description: "The bibliographic record does not exist." },
  CHECKOUT_NOT_FOUND: { kind: "BLOCK", description: "There is no active loan for this renewal." },
  CHECKOUT_PATRON_MISMATCH: { kind: "BLOCK", description: "The loan belongs to a different patron." },
  // patron standing
  PATRON_EXPIRED: { kind: "OVERRIDE", description: "Membership has expired (a confirmation for renewals)." },
  PATRON_RESTRICTED: { kind: "OVERRIDE", description: "The patron has an active restriction (manual, overdue suspension...)." },
  PATRON_DEBARRED: { kind: "OVERRIDE", description: "The account is not active." },
  PATRON_LOST_CARD: { kind: "OVERRIDE", description: "The card was reported lost." },
  FINES_OVER_LIMIT: { kind: "OVERRIDE", description: "Outstanding fines exceed noissuescharge (checkout) or maxoutstanding (holds)." },
  GUARANTEE_FINES_OVER_LIMIT: { kind: "CONFIRM", description: "Fines of the patron's guarantees exceed NoIssuesChargeGuarantees." },
  OVERDUES_BLOCK: { kind: "OVERRIDE", description: "The patron has overdue items (OverduesBlockCirc=block; a confirmation when set to confirmation)." },
  MAX_CHECKOUTS: { kind: "OVERRIDE", description: "The checkout limit of the rule is reached (limit 0 = not allowed)." },
  MAX_ONSITE: { kind: "OVERRIDE", description: "The on-site checkout limit of the rule is reached." },
  // item status
  ITEM_NOT_FOR_LOAN: { kind: "OVERRIDE", description: "The item is not for loan (allowed for on-site use)." },
  ITEMTYPE_NOT_FOR_LOAN: { kind: "OVERRIDE", description: "Items of this type are not for loan (allowed for on-site use)." },
  ITEM_ON_ORDER: { kind: "OVERRIDE", description: "The item is on order." },
  ITEM_IN_PROCESSING: { kind: "OVERRIDE", description: "The item is being processed." },
  ITEM_ON_DISPLAY: { kind: "OVERRIDE", description: "The item is on display." },
  ITEM_WITHDRAWN: { kind: "OVERRIDE", description: "The item is withdrawn." },
  ITEM_LOST: { kind: "CONFIRM", description: "The item is marked lost (IssueLostItem=confirm); it is marked found on checkout. A blocker for renewals." },
  ITEM_DAMAGED: { kind: "CONFIRM", description: "The item is marked damaged." },
  RESTRICTED_ITEM: { kind: "CONFIRM", description: "The item has restricted access." },
  ITEM_ALREADY_CHECKED_OUT: { kind: "CONFIRM", description: "Checked out to another patron (confirm to check it in first); a BLOCK with data.action=RENEW when it is the same patron." },
  ITEM_RESERVED_FOR_OTHER: { kind: "CONFIRM", description: "The item is on hold for, or another patron is next in the queue for it." },
  ITEM_RECALLED_FOR_OTHER: { kind: "CONFIRM", description: "The item is waiting for a patron who recalled it." },
  ITEM_IN_TRANSIT: { kind: "CONFIRM", description: "The item is in transit between libraries." },
  ITEM_AT_OTHER_LIBRARY: { kind: "CONFIRM", description: "The item belongs at another library branch." },
  // renewals
  RENEWALS_EXHAUSTED: { kind: "OVERRIDE", description: "No renewals left (not overridable when AllowRenewalLimitOverride is off)." },
  RENEWAL_TOO_EARLY: { kind: "OVERRIDE", description: "The rule does not allow renewing this early (noRenewalBeforeDays)." },
  ITEM_RESERVED: { kind: "OVERRIDE", description: "Other patrons are waiting for this item." },
  ITEM_RECALLED: { kind: "OVERRIDE", description: "The item has been recalled." },
  ONSITE_RENEWAL_NOT_ALLOWED: { kind: "OVERRIDE", description: "On-site loans cannot be renewed." },
  // check-in
  ITEM_LOST_RETURN_BLOCKED: { kind: "OVERRIDE", description: "BlockReturnOfLostItems is on." },
  ITEM_WITHDRAWN_RETURN_BLOCKED: { kind: "OVERRIDE", description: "BlockReturnOfWithdrawnItems is on." },
  RETURN_DATE_BEFORE_ISSUE: { kind: "BLOCK", description: "The back-dated return is before the checkout." },
  // holds
  HOLDS_NOT_ALLOWED: { kind: "OVERRIDE", description: "The patron category may not place holds." },
  MAX_HOLDS: { kind: "OVERRIDE", description: "The holds limit (rule, maxreserves, category override) is reached." },
  HOLDS_PER_RECORD: { kind: "OVERRIDE", description: "Too many holds by this patron on the same title." },
  ALREADY_ON_HOLD: { kind: "BLOCK", description: "The patron already has a hold on this exact item." },
  ALREADY_CHECKED_OUT_BY_PATRON: { kind: "OVERRIDE", description: "The patron already has this title on loan (AllowHoldsOnPatronsPossessions)." },
  NO_HOLDABLE_ITEMS: { kind: "OVERRIDE", description: "No item of the title can be placed on hold." },
  ITEM_NOT_HOLDABLE: { kind: "BLOCK", description: "The item is lost, withdrawn or not for loan." },
  ON_SHELF_HOLDS_DISALLOWED: { kind: "OVERRIDE", description: "The rule does not allow holds while copies are on the shelf." },
  PICKUP_LIBRARY_INVALID: { kind: "BLOCK", description: "The pickup library is unknown, inactive or not a pickup location." },
  HOLD_FEE: { kind: "CONFIRM", description: "The patron category charges a hold fee." },
  // alerts
  PATRON_MESSAGE: { kind: "ALERT", description: "A staff message on the patron account." },
  ITEM_NOTE: { kind: "ALERT", description: "The public note of the item." },
  ITEM_FOUND: { kind: "ALERT", description: "A lost / missing item turned up." },
  LOST_ITEM_REFUNDED: { kind: "ALERT", description: "The lost-item charge was refunded." },
  HOLD_FILLED: { kind: "ALERT", description: "The checkout fulfilled a hold." },
  PREVIOUS_LOAN_CLOSED: { kind: "ALERT", description: "The previous borrower's loan was checked in." },
  RENTAL_CHARGE: { kind: "ALERT", description: "A rental charge applies." },
  RENTAL_CHARGE_FAILED: { kind: "ALERT", description: "The rental charge could not be recorded." },
  NOT_CHECKED_OUT: { kind: "ALERT", description: "The scanned item was not on loan." },
  CLAIMS_RETURNED_RESOLVED: { kind: "ALERT", description: "A claims-returned flag was cleared by the return." },
  FINE_CHARGED: { kind: "ALERT", description: "An overdue fine was charged." },
  FINE_FAILED: { kind: "ALERT", description: "The overdue fine could not be calculated." },
  PATRON_SUSPENDED: { kind: "ALERT", description: "The patron was suspended after the overdue return." },
  HOLD_WAITING: { kind: "ALERT", description: "Put the item on the hold shelf for the named patron." },
  TRANSFER_NEEDED: { kind: "ALERT", description: "The item must be sent to another library." },
  TRANSFER_RECEIVED: { kind: "ALERT", description: "The item arrived from another library." },
  RECALL_WAITING: { kind: "ALERT", description: "The item is waiting for the patron who recalled it." },
  CHECKIN_MESSAGE: { kind: "ALERT", description: "The item type's check-in message." },
  LOCAL_USE_RECORDED: { kind: "ALERT", description: "Local use was recorded on return." }
};

// src/patrons.ts
var RESTRICTION_TYPES = ["MANUAL", "OVERDUES", "SUSPENSION", "EXPIRED", "DISCHARGE"];
var MESSAGING_NOTICE_TYPES = [
  { noticeType: "CHECKOUT", label: "Item checkout", supportsDigest: true, supportsAdvance: false },
  { noticeType: "CHECKIN", label: "Item check-in", supportsDigest: true, supportsAdvance: false },
  { noticeType: "PREDUE", label: "Item due soon", supportsDigest: true, supportsAdvance: true },
  { noticeType: "DUE", label: "Item due today", supportsDigest: true, supportsAdvance: false },
  { noticeType: "OVERDUE", label: "Overdue items", supportsDigest: true, supportsAdvance: false },
  { noticeType: "HOLD_READY", label: "Hold ready for pickup", supportsDigest: false, supportsAdvance: false },
  { noticeType: "HOLD_CANCELLED", label: "Hold cancelled", supportsDigest: false, supportsAdvance: false },
  { noticeType: "RENEWAL", label: "Item renewed", supportsDigest: false, supportsAdvance: false },
  { noticeType: "MEMBERSHIP_EXPIRY", label: "Membership expiry", supportsDigest: false, supportsAdvance: true },
  { noticeType: "ACCOUNT_PAYMENT", label: "Payment receipts", supportsDigest: false, supportsAdvance: false },
  { noticeType: "FINE_NOTICE", label: "Fines and fees", supportsDigest: false, supportsAdvance: false },
  { noticeType: "EVENT_REMINDER", label: "Event reminders", supportsDigest: false, supportsAdvance: true }
];
var PATRON_BATCH_OPERATIONS = ["RENEW_MEMBERSHIP", "CHANGE_CATEGORY", "CHANGE_LIBRARY", "ADD_RESTRICTION", "DELETE", "ANONYMISE"];

// src/fines.ts
var DEBIT_TYPE_INFO = [
  { code: "OVERDUE", label: "Overdue fine", description: "Accrues daily (or hourly) on a late loan.", manual: false, system: true },
  { code: "LOST_ITEM", label: "Lost item", description: "Replacement price charged when an item is declared lost.", manual: false, system: true },
  { code: "PROCESSING", label: "Lost item processing fee", description: "Processing fee charged together with a lost item.", manual: true, system: true },
  { code: "MANUAL_FEE", label: "Manual fee", description: "Any fee entered by staff.", manual: true, system: false },
  { code: "NEW_CARD", label: "New card fee", description: "Replacement of a lost membership card.", manual: true, system: false },
  { code: "MEMBERSHIP", label: "Membership fee", description: "Enrolment or renewal of membership.", manual: true, system: false },
  { code: "RENTAL", label: "Rental fee", description: "Charge for renting a title.", manual: true, system: false },
  { code: "HOLD_FEE", label: "Hold fee", description: "Fee for placing a hold.", manual: true, system: false },
  { code: "ARTICLE_REQUEST", label: "Article request fee", description: "Fee for an article or photocopy request.", manual: true, system: false },
  { code: "ROOM_BOOKING", label: "Room booking fee", description: "Fee for booking a study room or resource.", manual: true, system: false },
  { code: "ILL_FEE", label: "Interlibrary loan fee", description: "Charge passed on from the lending library.", manual: true, system: false },
  { code: "DAMAGE", label: "Damage fee", description: "Charge for a damaged item.", manual: true, system: false },
  { code: "OTHER", label: "Other", description: "Anything else.", manual: true, system: false }
];
var CREDIT_TYPE_INFO = [
  { code: "PAYMENT", label: "Payment", description: "Money received from the patron.", manual: false, system: false },
  { code: "WRITEOFF", label: "Write-off", description: "Library absorbs the charge.", manual: false, system: false },
  { code: "FORGIVEN", label: "Forgiven", description: "Charge forgiven (waived) by staff.", manual: false, system: false },
  { code: "DISCOUNT", label: "Discount", description: "Discount applied to charges.", manual: true, system: false },
  { code: "MANUAL_CREDIT", label: "Manual credit", description: "Credit added by staff.", manual: true, system: false },
  { code: "LOST_ITEM_REFUND", label: "Lost item refund", description: "Credit given when a lost item is found and returned.", manual: false, system: true },
  { code: "REFUND", label: "Refund (payout)", description: "Money paid back to the patron.", manual: false, system: false },
  { code: "CANCELLATION", label: "Cancellation", description: "A charge cancelled in error.", manual: false, system: true }
];

// src/admin.ts
var WEBHOOK_EVENTS = [
  "ping",
  "patron.created",
  "patron.updated",
  "patron.deleted",
  "checkout.created",
  "checkout.returned",
  "checkout.renewed",
  "hold.placed",
  "hold.ready",
  "hold.cancelled",
  "fine.charged",
  "fine.paid",
  "biblio.created",
  "biblio.updated",
  "biblio.deleted",
  "item.created",
  "item.updated",
  "item.deleted",
  "notice.sent",
  "news.published"
];

// src/tools.ts
var NOTICE_TEMPLATE_CODES = [
  "CHECKOUT",
  "ISSUESLIP",
  "CHECKIN",
  "DUE",
  "PREDUE",
  "OVERDUE_1",
  "OVERDUE_2",
  "OVERDUE_3",
  "HOLD_READY",
  "HOLD_CANCELLED",
  "HOLD_SLIP",
  "RENEWAL",
  "WELCOME",
  "MEMBERSHIP_EXPIRY",
  "PASSWORD_RESET",
  "OTP",
  "TRANSFER_SLIP",
  "ACCOUNT_PAYMENT",
  "ACCOUNT_WRITEOFF",
  "FINE_NOTICE",
  "ILL_UPDATE",
  "EVENT_REMINDER",
  "ROOM_BOOKING",
  "SERIAL_CLAIM",
  "SUGGESTION_UPDATE",
  "ARTICLE_REQUEST_UPDATE"
];
var SLIP_TYPES = ["issue", "checkout", "hold", "transfer", "receipt"];
var NOTICE_PREFERENCE_TYPES = [
  { type: "Advance_Notice", label: "Item due soon (advance notice)", codes: ["PREDUE"], digest: true, advanceDays: true },
  { type: "Item_Due", label: "Item due today", codes: ["DUE"], digest: true, advanceDays: false },
  { type: "Overdue", label: "Overdue notices", codes: ["OVERDUE_1", "OVERDUE_2", "OVERDUE_3"], digest: true, advanceDays: false },
  { type: "Item_Checkout", label: "Check-out receipts", codes: ["CHECKOUT"], digest: false, advanceDays: false },
  { type: "Item_Check_in", label: "Check-in (return) receipts", codes: ["CHECKIN"], digest: false, advanceDays: false },
  { type: "Hold_Filled", label: "Hold ready for pickup", codes: ["HOLD_READY", "HOLD_CANCELLED"], digest: false, advanceDays: false },
  { type: "Auto_Renewals", label: "Renewals", codes: ["RENEWAL"], digest: false, advanceDays: false },
  { type: "Account", label: "Fines, payments and receipts", codes: ["FINE_NOTICE", "ACCOUNT_PAYMENT", "ACCOUNT_WRITEOFF"], digest: false, advanceDays: false },
  { type: "Membership", label: "Membership expiry", codes: ["MEMBERSHIP_EXPIRY"], digest: false, advanceDays: false },
  { type: "Ill_update", label: "Interlibrary loan updates", codes: ["ILL_UPDATE"], digest: false, advanceDays: false },
  { type: "Events", label: "Events and room bookings", codes: ["EVENT_REMINDER", "ROOM_BOOKING"], digest: false, advanceDays: false },
  { type: "Requests", label: "Suggestions and article requests", codes: ["SUGGESTION_UPDATE", "ARTICLE_REQUEST_UPDATE"], digest: false, advanceDays: false }
];

// src/engagement.ts
var ILL_TYPES = ["BOOK", "ARTICLE", "CHAPTER", "THESIS", "AUDIOVISUAL", "OTHER"];
var ILL_NO_RETURN_TYPES = ["ARTICLE", "CHAPTER"];
var ILL_OPEN_STATUSES = ["REQUESTED", "REVIEWED", "ORDERED", "IN_TRANSIT", "RECEIVED", "OVERDUE"];
var ILL_TRANSITIONS = {
  REQUESTED: ["REVIEWED", "CANCELLED", "UNAVAILABLE"],
  REVIEWED: ["ORDERED", "CANCELLED", "UNAVAILABLE"],
  ORDERED: ["IN_TRANSIT", "RECEIVED", "CANCELLED", "UNAVAILABLE"],
  IN_TRANSIT: ["RECEIVED", "CANCELLED", "UNAVAILABLE"],
  RECEIVED: ["OVERDUE", "RETURNED", "COMPLETED"],
  OVERDUE: ["RECEIVED", "RETURNED", "COMPLETED"],
  RETURNED: ["COMPLETED"],
  COMPLETED: [],
  CANCELLED: [],
  UNAVAILABLE: []
};
var ERM_STATUSES = ["ACTIVE", "PENDING", "EXPIRED", "CLOSED"];
var ERM_RESOURCE_TYPES = ["JOURNAL", "BOOK", "DATABASE", "VIDEO", "AUDIO", "OTHER"];
var REGISTRATION_STATUSES = ["REGISTERED", "WAITLISTED", "CANCELLED", "ATTENDED", "NO_SHOW"];
var RESOURCE_KINDS = ["ROOM", "EQUIPMENT"];

// src/lists.ts
var LIST_SORT_FIELDS = ["manual", "title", "author", "year", "addedAt"];

// src/inventory.ts
var INVENTORY_SCAN_RESULTS = ["FOUND", "NOT_IN_CATALOG", "WRONG_LOCATION", "CHECKED_OUT", "WITHDRAWN", "LOST_FOUND", "DUPLICATE"];

// src/labels.ts
var LABEL_KINDS = ["SPINE", "BARCODE", "BARCODE_QR", "QR", "SHELF", "PATRON_CARD", "BOOKPLATE"];
var LABEL_FIELD_KEYS = [
  // items
  "title",
  "author",
  "callNumber",
  "barcode",
  "accessionNumber",
  "copy",
  "copiesTotal",
  "library",
  "location",
  "shelf",
  "position",
  "collection",
  "itemType",
  "volume",
  "isbn",
  "publisher",
  "year",
  "dateAccepted",
  // shelves
  "shelfName",
  "shelfCode",
  "aisle",
  "rack",
  "level",
  "callNumberRange",
  "capacity",
  "itemCount",
  // patrons
  "patronName",
  "cardNumber",
  "category",
  "validUntil",
  "memberSince",
  "libraryAddress"
];
var LABEL_FIELD_NAMES = {
  title: "Title",
  author: "Author",
  callNumber: "Call number",
  barcode: "Barcode",
  accessionNumber: "Accession no.",
  copy: "Copy (2 of 5)",
  copiesTotal: "Total copies",
  library: "Library",
  location: "Location",
  shelf: "Shelf",
  position: "Exact position",
  collection: "Collection",
  itemType: "Item type",
  volume: "Volume",
  isbn: "ISBN",
  publisher: "Publisher",
  year: "Year",
  dateAccepted: "Date accepted",
  shelfName: "Shelf name",
  shelfCode: "Shelf code",
  aisle: "Aisle",
  rack: "Rack",
  level: "Level",
  callNumberRange: "Call number range",
  capacity: "Capacity",
  itemCount: "Items on shelf",
  patronName: "Name",
  cardNumber: "Card number",
  category: "Category",
  validUntil: "Valid until",
  memberSince: "Member since",
  libraryAddress: "Library address"
};
function shelfPositionText(p) {
  return [
    p.library,
    p.location,
    p.aisle ? `Aisle ${p.aisle}` : null,
    p.rack ? `Rack ${p.rack}` : null,
    p.level ? `Shelf ${p.level}` : null,
    p.slot ? `Slot ${p.slot}` : null
  ].filter(Boolean).join(" > ");
}
export {
  ARTICLE_REQUEST_STATUSES,
  AUTHORITY_TYPE_CODES,
  BARCODE_FORMATS,
  BASKET_STATUSES,
  BOOKING_STATUSES,
  CIRCULATION_ISSUE_CATALOG,
  CREDIT_TYPES,
  CREDIT_TYPE_INFO,
  CSV_IMPORT_FIELDS,
  DEBIT_TYPES,
  DEBIT_TYPE_INFO,
  ERM_RESOURCE_TYPES,
  ERM_STATUSES,
  EVENT_STATUSES,
  GENDERS,
  HARD_DUE_DATE_MODES,
  HOLD_STATUSES,
  HOLIDAY_KINDS,
  ILL_NO_RETURN_TYPES,
  ILL_OPEN_STATUSES,
  ILL_STATUSES,
  ILL_TRANSITIONS,
  ILL_TYPES,
  IMPORT_SOURCES,
  IMPORT_STATUSES,
  INVENTORY_SCAN_RESULTS,
  LABEL_FIELD_KEYS,
  LABEL_FIELD_NAMES,
  LABEL_KINDS,
  LIST_SORT_FIELDS,
  LIST_VISIBILITIES,
  LOAN_UNITS,
  LOST_STATUSES,
  MESSAGE_STATUSES,
  MESSAGING_NOTICE_TYPES,
  NOTICE_MEDIUMS,
  NOTICE_PREFERENCE_TYPES,
  NOTICE_TEMPLATE_CODES,
  NOT_FOR_LOAN_STATUSES,
  OFFLINE_OP_STATUSES,
  OFFLINE_OP_TYPES,
  ORDER_STATUSES,
  PATRON_BATCH_OPERATIONS,
  PATRON_CATEGORY_TYPES,
  PATRON_STATUSES,
  PAYMENT_METHODS,
  PERMISSIONS,
  PERMISSION_LABELS,
  PRIVACY_POLICIES,
  RECALL_STATUSES,
  REGISTRATION_STATUSES,
  RESOURCE_KINDS,
  RESTRICTION_TYPES,
  ROLE_PERMISSIONS,
  SERIAL_ISSUE_STATUSES,
  SLIP_TYPES,
  STAFF_ROLES,
  SUBSCRIPTION_FREQUENCIES,
  SUGGESTION_STATUSES,
  TRANSFER_REASONS,
  WEBHOOK_EVENTS,
  WEEKDAY_KEYS,
  effectivePermissions,
  hasPermission,
  shelfPositionText
};
